var _ScreenReaderOnly;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled, { keyframes } from 'styled-components';
import { AlertDialogLabel, AlertDialogDescription, AlertDialogContent } from '@reach/alert-dialog';
import { screenReaderOnly } from '../Mixins/Mixins';
import { Link, PrimaryButton, TertiaryButton, Box, Text, Image, BanksyImage } from '../../';
import { animateDuration } from './config';
var ScreenReaderOnly = styled.div.withConfig({
  displayName: "InnerDialog__ScreenReaderOnly",
  componentId: "sc-1kpmekh-0"
})(["", ""], screenReaderOnly);
var dropInUp = keyframes(["0%{transform:translateY(20px);}100%{transform:translateY(0);}"]);
export var DialogPrompt = styled.div.withConfig({
  displayName: "InnerDialog__DialogPrompt",
  componentId: "sc-1kpmekh-1"
})(["max-height:65vh;overflow-y:scroll;font-size:", ";margin-bottom:", ";white-space:pre-wrap;overflow:auto;-webkit-overflow-scrolling:touch;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.s;
});
var StyledAlertDialogContent = styled(AlertDialogContent).withConfig({
  displayName: "InnerDialog__StyledAlertDialogContent",
  componentId: "sc-1kpmekh-2"
})(["position:relative;width:", ";border-radius:0.5rem;max-width:", ";color:", ";padding:", ";box-sizing:border-box;text-align:center;box-shadow:", ";background-color:", ";animation:", " ease-out ", "ms;"], function (props) {
  return props.width || '90%';
}, function (_ref3) {
  var width = _ref3.width;
  return width || '30rem';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.textPrimary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.m;
}, function (p) {
  return p.theme.shadows.shadow16;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.bgElevated;
}, dropInUp, animateDuration);

var DialogActions = function DialogActions(_ref7) {
  var animatedCancel = _ref7.animatedCancel,
      cancelText = _ref7.cancelText,
      confirmText = _ref7.confirmText,
      needHelpLink = _ref7.needHelpLink,
      confirm = _ref7.confirm,
      hideConfirmButton = _ref7.hideConfirmButton,
      shouldRenderHelpLink = _ref7.shouldRenderHelpLink,
      leastDestructiveRef = _ref7.leastDestructiveRef,
      setAnimatingOut = _ref7.setAnimatingOut;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideConfirmButton && /*#__PURE__*/React.createElement(Box, {
    maxWidth: "16rem",
    mx: "auto"
  }, /*#__PURE__*/React.createElement(PrimaryButton, {
    type: "button",
    onClick: function onClick() {
      setAnimatingOut(true);
      setTimeout(function () {
        setAnimatingOut(false);
        confirm();
      }, animateDuration);
    }
  }, confirmText || 'Got it')), cancelText ? /*#__PURE__*/React.createElement(Box, {
    maxWidth: "16rem",
    mx: "auto",
    mt: "xs"
  }, /*#__PURE__*/React.createElement(TertiaryButton, {
    my: "0",
    onClick: animatedCancel,
    ref: leastDestructiveRef
  }, cancelText)) : shouldRenderHelpLink ? /*#__PURE__*/React.createElement(Box, {
    mt: "s",
    mx: "auto",
    p: "xxs"
  }, /*#__PURE__*/React.createElement(Link, {
    "data-test": "dialog__need-help",
    target: "_blank",
    href: needHelpLink,
    ref: leastDestructiveRef
  }, "Need help?")) : null);
};

var InnerDialog = function InnerDialog(props) {
  var emojiHeading = props.emojiHeading,
      emojiHeadingLabel = props.emojiHeadingLabel,
      jumboHeading = props.jumboHeading,
      image = props.image,
      banksyImage = props.banksyImage,
      imageHeight = props.imageHeight,
      imageWidth = props.imageWidth,
      imageAlt = props.imageAlt,
      heading = props.heading,
      prompt = props.prompt,
      setAnimatingOut = props.setAnimatingOut,
      align = props.align,
      width = props.width,
      leastDestructiveRef = props.leastDestructiveRef;
  var promptIsJSX = /*#__PURE__*/React.isValidElement(prompt);
  return /*#__PURE__*/React.createElement(StyledAlertDialogContent, {
    width: width
  }, /*#__PURE__*/React.createElement(AlertDialogLabel, null, image && /*#__PURE__*/React.createElement(Image, {
    src: image,
    maxHeight: imageHeight,
    maxWidth: imageWidth,
    alt: imageAlt,
    mx: "auto",
    mb: "s"
  }), banksyImage && /*#__PURE__*/React.createElement(BanksyImage, {
    src: banksyImage,
    maxHeight: imageHeight,
    maxWidth: imageWidth,
    alt: imageAlt,
    mx: "auto",
    mb: "s"
  }), emojiHeading && /*#__PURE__*/React.createElement(Text.Display, {
    mb: "xxs",
    align: align
  }, /*#__PURE__*/React.createElement("span", {
    role: "img",
    "aria-label": emojiHeadingLabel || emojiHeading
  }, emojiHeading)), jumboHeading || heading ? /*#__PURE__*/React.createElement(Text.H2, {
    size: jumboHeading ? 1 : 3,
    mb: "xxs",
    align: align
  }, jumboHeading || heading) : _ScreenReaderOnly || (_ScreenReaderOnly = /*#__PURE__*/React.createElement(ScreenReaderOnly, null, /*#__PURE__*/React.createElement("h2", null, "Alert")))), /*#__PURE__*/React.createElement(AlertDialogDescription, null, /*#__PURE__*/React.createElement(DialogPrompt, null, promptIsJSX ? prompt : /*#__PURE__*/React.createElement(Text, {
    align: align
  }, prompt))), /*#__PURE__*/React.createElement(DialogActions, _extends({}, props, {
    setAnimatingOut: setAnimatingOut,
    leastDestructiveRef: leastDestructiveRef
  })));
};

export default InnerDialog;